<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow"
                :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getMainTableRecords"
                    :table-search="mainTable.tableSearch" />
                </Col>
            </Row>
        </transition>

        <Card>
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">标准卡管理</span>
                    </div>
                    <div class="right-bar">
                        <Button v-if="readOnly === false"
                            class="btns"
                            size="small"
                            shape="circle"
                            type="success"
                            icon="ios-add-circle-outline"
                            @click="onCreate">新增</Button>

                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.tableColumns"
                    :data="mainTable.tableData"
                    :loading="mainTable.tableLoading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getMainTableRecords" />
                </Col>
            </Row>
        </Card>

        <StandardCardEdit :readOnly="readOnly"
            ref="standardCardModal" />
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import SingleFileUploadWithName from '@/components/single-file-upload-with-name/SingleFileUploadWithName';
import { APPROVAL_NO, APPROVAL_YES, approvalFormat } from '@/libs/baseModelFormat';
import { singleImageRender } from '@/libs/tableRowImageRender';
import StandardCardEdit from './standardCard-edit';
import { getStandardCardList } from '@/api/modules/product-management/standardCard-management';

export default {
    name: 'standardCardList',
    components: {
        SingleFileUploadWithName,
        StandPaginationTable,
        SearchCard,
        StandardCardEdit
    },
    props: {
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            mainTable: {
                tableColumns: [
                    { title: '行号', type: 'index', width: 60, align: 'center' },
                    { title: '大类', key: 'mainCategoryName', align: 'center' },
                    { title: '小类', key: 'subCategoryName', align: 'center' },
                    { title: '专家', key: 'masterName', align: 'center' },
                    { title: '专家编号', key: 'masterCode', align: 'center' },
                    { title: '名称', key: 'standardCardName', align: 'center' },
                    { title: '描述', key: 'standardCardDesc', align: 'center', tooltip: true },
                    { title: '图片', key: 'standardCardImageFile', align: 'center', render: (h, params) => singleImageRender(h, params.row.standardCardImageFile) },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    on: {
                                        click: () => {
                                            this.onDetail(params.row);
                                        }
                                    }
                                }, '查看')
                            ]);
                        }
                    }
                ],
                tableData: [],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                searchForm: [
                    { label: '大类', type: 'Input', value: '', name: 'mainCategoryName', sql: 'like' },
                    { label: '小类', type: 'Input', value: '', name: 'subCategoryName', sql: 'like' },
                    { label: '专家', type: 'Input', value: '', name: 'masterName', sql: 'like' },
                    { label: '名称', type: 'Input', value: '', name: 'standardCardName', sql: 'like' }
                ],
                sarchCardShow: false
            }
        };
    },
    // beforeRouteLeave(to, from, next) {
    //     this.mainTable.tableData = [];
    //     this.$destroy();
    //     next();
    // },
    mounted() {
        this.init();
    },
    methods: {
        approvalFormat,
        init() {
            this.approvalSource = [];
            this.approvalSource.push({ val: APPROVAL_NO, label: approvalFormat(APPROVAL_NO) });
            this.approvalSource.push({ val: APPROVAL_YES, label: approvalFormat(APPROVAL_YES) });

            this.getMainTableRecords();
        },
        getMainTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            getStandardCardList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.tableData = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.tableLoading = false;
            });
        },
        onCreate() {
            this.$refs.standardCardModal.showModal();
            // this.$router.push({
            //     name: 'standardCard-edit'
            // });
        },
        // onUpdate(row) {
        //     this.$router.push({
        //         name: 'standardCard-edit',
        //         query: {
        //             standardCardUuid: row.standardCardUuid
        //         }
        //     });
        // },
        onDetail(row) {
            this.$refs.standardCardModal.showModal(row.standardCardUuid);
            // this.$router.push({
            //     name: 'standardCard-edit',
            //     query: {
            //         standardCardUuid: row.standardCardUuid
            //     }
            // });
        }
    }
};
</script>

<style scoped lang="less">
@titleHeight: 25px;

.border {
    border: 1px solid #c9c9c9;
    margin-bottom: 5px;
    padding: 5px 5px 5px 5px;
}

.title {
    height: @titleHeight;

    .text {
        font-weight: bold;
        float: left;
        line-height: @titleHeight;
    }

    .action {
        float: right;
    }
}
</style>
